// ここ以外では参照されないので近い場所に定義する

// effect
export const AuthzPolicyEffectValues = ['PERMIT', 'FORBID'] as const
type AuthzPolicyEffect = (typeof AuthzPolicyEffectValues)[number]
export const AuthzPolicyEffectText: Record<AuthzPolicyEffect, string> = {
  PERMIT: '許可',
  FORBID: '禁止',
}

export const AuthzPolicyPrincipalTypeValues = [
  'AnyAuthzPolicyPrincipal',
  'StaffAuthzPolicyPrincipal',
  'TeamAuthzPolicyPrincipal',
] as const
type AuthzPolicyPrincipalType = (typeof AuthzPolicyPrincipalTypeValues)[number]
export const AuthzPolicyPrincipalTypeText: Record<
  AuthzPolicyPrincipalType,
  string
> = {
  AnyAuthzPolicyPrincipal: '全スタッフ',
  StaffAuthzPolicyPrincipal: '特定のスタッフ',
  TeamAuthzPolicyPrincipal: '特定のチーム',
}

// action
export const AuthzPolicyActionTypeValues = [
  'AnyAuthzPolicyAction',
  'ReadRoomAuthzPolicyAction',
] as const
export type AuthzPolicyActionType = (typeof AuthzPolicyActionTypeValues)[number]
export const AuthzPolicyActionTypeText: Record<AuthzPolicyActionType, string> =
  {
    AnyAuthzPolicyAction: '任意の操作',
    ReadRoomAuthzPolicyAction: 'チャットの閲覧',
  }

// resource
export const AuthzPolicyResourceTypeValues = [
  'AnyAuthzPolicyResource',
  'RoomAuthzPolicyResource',
] as const
type AuthzPolicyResourceType = (typeof AuthzPolicyResourceTypeValues)[number]
export const AuthzPolicyResourceTypeText: Record<
  AuthzPolicyResourceType,
  string
> = {
  AnyAuthzPolicyResource: '任意のリソース',
  RoomAuthzPolicyResource: '特定のチャット',
}
export const PossibleResourceTypes: Record<
  AuthzPolicyActionType,
  AuthzPolicyResourceType[]
> = {
  AnyAuthzPolicyAction: ['AnyAuthzPolicyResource'],
  ReadRoomAuthzPolicyAction: [
    'AnyAuthzPolicyResource',
    'RoomAuthzPolicyResource',
  ],
}
